import {$} from '../utils';

// Project Overview marquee component
const Stepper = () => {
    // Getting the element
    const element = document.getElementById('stepper');
    
    // Return if element not exist
    if (!element) return;

    const steps = element.querySelectorAll('.step');
    
    // Getting stepper buttons
    const stepperButtons = document.querySelectorAll('.stepperButtons');
    const previousButtons = document.querySelectorAll('.stepperPrev');
    const nextButtons = document.querySelectorAll('.stepperNext');

    // Method to handle previous click
    const onPrevious = (e) => {
        // Prevent default event of button
        e.preventDefault();
        // Typecast steps to array
        const _steps = [...steps];
        // Getting active index of stepper
        const active = _steps.findIndex((x) => x.classList.contains('active'));
        // Chnage active step
        if (active > 0) {
            // Next step
            const previous = active - 1;
            // Remove active form current step
            steps[active].classList.remove('active');
            // Activate next step
            steps[previous].classList.add('active');
        }
    };

    // Method to handle next click
    const onNext = (e) => {
        // Prevent default event of button
        e.preventDefault();
        // Typecast steps to array
        const _steps = [...steps];
        // Getting active index of stepper
        const active = _steps.findIndex((x) => x.classList.contains('active'));
        // Chnage active step
        if (active < steps.length) {
            // Next step
            const next = active + 1;
            // Remove active form current step
            steps[active].classList.remove('active');
            // Activate next step
            steps[next].classList.add('active');
        }
    };

    // Adding events listeners to previous buttons
    $(previousButtons, (button) => {
        button.addEventListener('click', onPrevious);
    });

    // Adding events listeners to next buttons
    $(nextButtons, (button) => {
        button.addEventListener('click', onNext);
    });
   
};

// Export component
export default Stepper;